import { isPossiblePhoneNumber } from "libphonenumber-js";

$( document ).ready( () => {
  window.$.validator.addMethod(
    "regexp",
    function (value, element, regexp) {
      return isPossiblePhoneNumber(value);
    },
    "Введите корректный номер телефона"
  );
  window.$('._email').on("input", function (e) {
    e.target.value = e.target.value.replaceAll(' ', '');
  });

  window.$("#footer-form").validate({
    submitHandler: function (form) {
      form.submit();
    },
    errorElement: "span",
    errorClass: "_error",
    errorPlacement: function (error, element) {
      error.appendTo(element.siblings(".input-field__helper"));
    },
    rules: {
      name: {
        required: true,
        minlength: 2,
      },
      email: {
        required: true,
        email: true,
      },
      phone: {
        required: true,
        minlength: 11,
      },
    },
    messages: {
      name: {
        required: "Поле обязательно для заполнения",
        minlength: "Введите корректное имя",
      },
      phone: {
        required: "Поле обязательно для заполнения",
        minlength: "Длина номера должна составлять 11 цифр",
      },
      email: {
        required: "Поле обязательно для заполнения",
        email: "Введите адрес электронной почты в формате name@domain.com",
      },
    },
  });
  
  window.$("#basket-form").validate({
    submitHandler: function (form) {
      form.submit();
    },

    errorElement: "span",
    errorClass: "_error",

    errorPlacement: function (error, element) {
      if (element.attr("type") === "checkbox") {
        error.appendTo(
          element.parent(".checkbox__body").siblings(".checkbox__helper")
        );
      }

      error.appendTo(
        element
          .parent(".outline-field__body")
          .siblings(".outline-field__helper")
      );
    },
    highlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").addClass(errorClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").removeClass(errorClass);
    },

    rules: {
      basket_name: {
        required: true,
        minlength: 2,
      },
      basket_email: {
        required: true,
        email: true,
      },
      basket_phone: {
        required: true,
        minlength: 11,
      },
      basket_policy: { required: true },
    },
    messages: {
      basket_name: {
        required: "Поле обязательно для заполнения",
        minlength: "Введите корректное имя",
      },
      basket_phone: {
        required: "Поле обязательно для заполнения",
        minlength: "Длина номера должна составлять 11 цифр",
      },
      basket_email: {
        required: "Поле обязательно для заполнения",
        email: "Введите адрес электронной почты в формате name@domain.com",
      },
      basket_policy: {
        required: "Поле обязательно для заполнения",
      },
    },
  });
  window.$("#signin-form").validate({
    submitHandler: function (form) {
      form.submit();
    },
    debug: false,
    errorElement: "span",
    errorClass: "_error",

    errorPlacement: function (error, element) {
      if (element.attr("type") === "checkbox") {
        error.appendTo(
          element.parent(".checkbox__body").siblings(".checkbox__helper")
        );
      }

      error.appendTo(
        element
          .parent(".outline-field__body")
          .siblings(".outline-field__helper")
      );
    },
    highlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").addClass(errorClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").removeClass(errorClass);
    },

    rules: {
      signin_password: {
        required: true,
        minlength: 8,
      },
      signin_phone: {
        required: true,
      },
    },
    messages: {
      signin_password: {
        required: "Поле обязательно для заполнения",
        minlength: "Длина пароля должна быть не менее 8 символов",
      },
      signin_phone: {
        required: "Поле обязательно для заполнения",
        minlength: "Длина номера должна составлять 11 цифр",
      },
    },
  });
  window.$("#signup-form").validate({
    submitHandler: function (form) {
      form.submit();
    },
    debug: false,
    errorElement: "span",
    errorClass: "_error",

    errorPlacement: function (error, element) {
      if (element.attr("type") === "checkbox") {
        error.appendTo(
          element.parent(".checkbox__body").siblings(".checkbox__helper")
        );
      }
      error.appendTo(
        element
          .parent(".outline-field__body")
          .siblings(".outline-field__helper")
      );
    },
    highlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").addClass(errorClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").removeClass(errorClass);
    },

    rules: {
      signup_fname: {
        required: true,
        minlength: 2,
      },
      signup_lname: {
        required: true,
        minlength: 2,
      },
      signup_phone: {
        required: true,
        minlength: 11,
      },
      signup_email: {
        required: true,
        email: true,
      },
      signup_policy: {
        required: true,
      },
    },
    messages: {
      signup_fname: {
        required: "Поле обязательно для заполнения",
        minlength: "Введите имя полностью",
      },
      signup_lname: {
        required: "Поле обязательно для заполнения",
        minlength: "Введите фамилию полностью",
      },
      signup_phone: {
        required: "Поле обязательно для заполнения",
        minlength: "Длина номера должна составлять 11 цифр",
      },
      signup_email: {
        required: "Поле обязательно для заполнения",
        email: "Введите адрес электронной почты в формате name@domain.com",
      },
      signup_policy: {
        required: "Поле обязательно для заполнения",
      },
    },
  });
  window.$("#restore-form").validate({
    submitHandler: function (form) {
      form.submit();
    },

    errorElement: "span",
    errorClass: "_error",

    errorPlacement: function (error, element) {
      if (element.attr("type") === "checkbox") {
        error.appendTo(
          element.parent(".checkbox__body").siblings(".checkbox__helper")
        );
      }

      error.appendTo(
        element
          .parent(".outline-field__body")
          .siblings(".outline-field__helper")
      );
    },
    highlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").addClass(errorClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").removeClass(errorClass);
    },

    rules: {
      restore_phone: {
        required: true,
        minlength: 11,
        regexp: true,
      },
    },
    messages: {
      restore_phone: {
        required: "Поле обязательно для заполнения",
        minlength: "Длина номера должна составлять 11 цифр",
      },
    },
  });
  window.$("#pf-sub-form").validate({
    submitHandler: function (form) {
      form.submit();
    },

    errorElement: "span",
    errorClass: "_error",

    errorPlacement: function (error, element) {
      if (element[0].tagName === "SELECT") {
        error.appendTo(element.siblings(".select__error"));
      }

      error.appendTo(
        element
          .parent(".outline-field__body")
          .siblings(".outline-field__helper")
      );
    },
    highlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").addClass(errorClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      window.$(element).parent(".outline-field__body").removeClass(errorClass);
    },
    rules: {
      period_id: {
        required: true,
      },
    },
    messages: {
      period_id: {
        required: "Выберите одну из опций",
      },
    },
  });
  
});
